import React, { useState } from "react";
import CountryContext from "./countryContext";

const CountryProvider = ({ children }) => {
  const [countryContextState, setCountryContextState] = useState({
    country: null,
  });

  return (
    <CountryContext.Provider
      value={{
        countryContextState,
        setCountryContextState,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
};

export default CountryProvider;
